// Replace with your request types
export const GET_TAKEY_RESTAURANT_REQUEST = 'GET_TAKEY_RESTAURANT_REQUEST';
export const GET_TAKEY_RESTAURANT_RECEIVE = 'GET_TAKEY_RESTAURANT_RECEIVE';
export const CLEAR_TAKEY_RESTURANT = 'CLEAR_TAKEY_RESTURANT';
